"use client";
import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQs } from "@/constants/faq";
import { MixpanelTracking } from "@/lib/mixpanel-browser-analytics";
function FAQPage() {
	return (
		<div className="container flex justify-center">
			<div className="p-5 max-w-[2000px] w-full md:p-10 md:w-[70%]">
				<br />
				<h3 className="text-3xl font-semibold ">
					Frequently Asked Questions (FAQ)
				</h3>
				<br />
				<Accordion type="single" collapsible className="">
					{FAQs.map((faq) => (
						<AccordionItem
							key={faq.id}
							value={faq.id.toString()}
							onClick={() =>
								MixpanelTracking.getInstance().faqClicked(faq.question)
							}>
							<AccordionTrigger className="justify-start text-left hover:no-underline hover:text-blue-500">
								<b className="mr-1">Q.</b>{" "}
								<div className="mr-auto">{faq.question}</div>
							</AccordionTrigger>
							<AccordionContent className="text-base text-center">
								{faq.answer}
							</AccordionContent>
						</AccordionItem>
					))}
				</Accordion>
			</div>
		</div>
	);
}

export default FAQPage;
